import { Flex, Heading, Image, Spacer, Text, VStack } from "@chakra-ui/react";
import DashboardTable from "../../components/DashboardTable/DashboardTable";

const Dashboard = () => {
  // const { masterHome, busy } = useHomeMaster();
  // const { isOpen, onOpen, onClose } = useDisclosure();
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   // if (!busy && !(masterCategory || []).length) {
  //   dispatch({ type: REQUEST_MASTER_HOME });
  //   // }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  // const [searchQuery, setSearch] = useState("");

  return (
    <>
      <VStack top={5} position="relative" key={"vStack"}>
        <Flex w="92%" alignItems="center" justifyContent="space-between">
          <Heading ml="8" size="md" fontWeight="semibold" color="black.400">
            Dashboard
          </Heading>
          <Spacer></Spacer>
          <Heading size="sm" fontWeight="semibold">
            <Flex alignItems="center" gap={2}>
              <Image
                borderRadius="full"
                boxSize="50px"
                src="https://bit.ly/dan-abramov"
                alt="Dan Abramov"
              />
              <Text>Admin</Text>
            </Flex>
          </Heading>
        </Flex>
      </VStack>
      <DashboardTable />
      {/* {isOpen && <HomeMasterEditDrawer isOpen onClose={onClose} />} */}
    </>
  );
};

export default Dashboard;
